module.exports = __webpack_public_path__ + "img/gh.b21ce031.svg";